import React from 'react';

import { Tag } from 'antd';

import { EPaymentMethod } from 'v2/interfaces/shopping';
import type { ShoppingDelivery } from 'v2/interfaces/shopping';

import { getInvoiceStatusColor } from './colors';
import { updateDeliveryStatus } from './updateDeliveryStatus';

type PaymentStatusTagProps = {
  delivery: ShoppingDelivery;
};

function PaymentStatusTag({ delivery }: PaymentStatusTagProps) {
  let status = delivery.payment_status;

  if (delivery.payment_method.id === EPaymentMethod.BOLETO_PARCELADO) {
    status = updateDeliveryStatus(delivery);
  }

  return (
    <Tag key={`status-tag-${delivery.invoice_id}`} className='-me-2' color={getInvoiceStatusColor(status.id)}>
      {status.name}
    </Tag>
  );
}

export default PaymentStatusTag;
